import React from 'react'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  padding: 88px 20px;
  text-align: center;
  p {
    width: 100%;
  }
  ${({ theme }) => theme.media.desktop} {
    padding: 88px 0px;
    p {
      width: 66%;
    }
  }
`

const CustomerSatisfaction = ({ children }) => (
  <StyledWrapper>{children}</StyledWrapper>
)

export default CustomerSatisfaction
